/** Describe selected classes first, falling back to explicit cars for Any class. */
export function getChampionshipCarsLabel(
  championship,
  { multiClassLabel } = {},
) {
  const classNames = (championship?.carClasses || [])
    .map((entry) => entry.carClass?.name)
    .filter(Boolean)

  if (classNames.length > 1 && multiClassLabel) return multiClassLabel
  if (classNames.length) return classNames.join(', ')

  const carNames = (championship?.cars || [])
    .map((entry) => entry.car?.name)
    .filter(Boolean)
  return [...new Set(carNames)].join(', ') || 'N/A'
}
